import React from 'react';
import LazyMetrics from '../../states-year/LazyMetrics';
import TotalYear from '../../states-year/Organizations/TotalYear';
import OrganizationGrowthByMonth from '../../states-year/Organizations/OrganizationGrowthByMonth';
import CompositeOrganizationGrowth from '../../states-year/Organizations/CompositeOrganizationGrowth';

export default function Organizations(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics title="Organizations associated/affiliated with Partners">
        <TotalYear {...params} titleOnly={true} />
      </LazyMetrics>
      <LazyMetrics
        title="Growth"
        columns={1}
      >
        <OrganizationGrowthByMonth {...params} />
        {/*<div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">*/}
        {/*  <CompositeOrganizationGrowth {...params} titleOnly={true} />*/}
        {/*</div>*/}
      </LazyMetrics>
    </>
  );
}
